module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAMCAYAAABfnvydAAAABHNCSVQICAgIfAhkiAAAAMtJREFUGJVtkD1qw0AQhd8bC1ZSAsaF89PmGNvrBK5yA8sHSty6SpVWILZQp2OkTZoQUkhGzb5UgWXtqWb4PuYNw67rts65XVVVJ+/9GVmZc24n6Wmapv04jtWFEGN8A/BD8nGe5zaXrGmaX0kvJL8BPOQS/5thGG5jjHtJdwC+6rp+9d6fma7r+/6mKIo2lSw/SlJM51UaQbIFcJ9GrAAghLAGcJC0TSEAMISwJnkAsMkhABRm9ixpY2afZVke82/asizvJD+uQQD4A4Y0XnT+TgcTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/arrow-grey.png
// module id = 571
// module chunks = 0